import { FIREFLY_TARGET_ATTR } from "@/lib/firefly/fireflyTargetConvention";
import {
  type OpsPaperworkTab,
  opsPaperworkTabLabel,
} from "@/lib/ops/opsPaperworkTabs";

export function OpsPaperworkTabs(props: {
  tabs: OpsPaperworkTab[];
  active: OpsPaperworkTab;
  unmappedLots: number;
  onSelect: (tab: OpsPaperworkTab) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2 border-b border-gray-200 pb-2">
      {props.tabs.map((t) => (
        <button
          key={t}
          type="button"
          {...(t === "deals" ? { [FIREFLY_TARGET_ATTR]: "ops-deals-tab" } : {})}
          {...(t === "locations" ? { [FIREFLY_TARGET_ATTR]: "ops-locations-tab" } : {})}
          onClick={() => props.onSelect(t)}
          className={`px-3 py-1 rounded-full text-sm ${
            props.active === t ? "bg-indigo-600 text-white" : "bg-gray-100 text-gray-800"
          }`}
        >
          {opsPaperworkTabLabel(t)}
          {t === "locations" && props.unmappedLots > 0 ? (
            <span
              className={`ml-1.5 inline-flex min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-[11px] font-semibold ${
                props.active === t ? "bg-amber-300 text-amber-950" : "bg-amber-400 text-amber-950"
              }`}
              title={`${props.unmappedLots} unmapped host lot${props.unmappedLots === 1 ? "" : "s"}`}
            >
              {props.unmappedLots}
            </span>
          ) : null}
        </button>
      ))}
    </div>
  );
}
